var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6891_5482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6152 0C14.3853 0 16.4053 1.715 16.7553 4.085C16.9803 5.62 16.5602 6.995 15.4753 8.115C13.7752 9.87 12.0452 11.595 10.3302 13.335C9.16525 14.515 8.00025 15.69 6.84025 16.87C6.06025 17.66 5.12025 18.04 4.01025 18C2.35025 17.945 0.845249 16.56 0.645249 14.915C0.495249 13.685 0.865249 12.64 1.74525 11.77C3.78525 9.745 5.82025 7.715 7.86025 5.69C8.68025 4.875 9.84025 4.69 10.7602 5.215C12.0252 5.94 12.2852 7.685 11.2602 8.785C10.6102 9.485 9.91525 10.145 9.24025 10.82C7.92525 12.135 6.60525 13.455 5.29025 14.77C5.11025 14.955 4.90525 15.045 4.65025 14.98C4.22025 14.865 4.06525 14.345 4.35525 14.005C4.40025 13.955 4.45025 13.905 4.50025 13.855C6.41525 11.94 8.32525 10.025 10.2402 8.115C10.5852 7.77 10.7552 7.375 10.6452 6.895C10.4952 6.25 9.77525 5.935 9.13525 6.235C8.98025 6.31 8.83525 6.42 8.71525 6.54C6.65025 8.585 4.59025 10.625 2.54025 12.675C1.86025 13.355 1.64025 14.18 1.92025 15.1C2.19525 16 2.82525 16.555 3.74525 16.74C4.60525 16.91 5.34525 16.65 5.96525 16.025C8.01025 13.96 10.0503 11.89 12.0903 9.825C12.9202 8.985 13.7552 8.15 14.5803 7.3C16.4853 5.335 15.6103 2.06 12.9753 1.335C11.6702 0.975 10.4802 1.265 9.51525 2.21C6.70025 4.975 3.91525 7.76 1.11025 10.535C0.990249 10.655 0.815249 10.75 0.650249 10.78C0.395249 10.83 0.160249 10.67 0.0602488 10.44C-0.0397512 10.2 -0.0147512 9.97 0.170249 9.78C0.415249 9.525 0.675249 9.275 0.925249 9.025C3.47025 6.505 6.01525 3.98 8.56025 1.45C9.51025 0.505 10.6552 0.015 11.6152 0Z",
    fill: "#06C9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6891_5482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.81,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentImg);
export default __webpack_public_path__ + "static/media/attachmentImg.1a99ed8fba43afa5b11b0dc33cb66a5c.svg";
export { ForwardRef as ReactComponent };